import { useLocation, useNavigate } from "react-router-dom";
import ViewStoryContent from "./ViewStoryContent";
import { RouteUrl } from "utils";

export default function ViewStoryPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("user_id");

  return <ViewStoryContent userId={userId} onClose={() => navigate(RouteUrl.newsFeed)} />;
}

